import './Modal.scss';

import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import { MODAL_STYLE_RESET } from 'utils/constants';

export default class Modal extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        contentLabel: PropTypes.string,
        show: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])
    };

    render() {
        return (
            <ReactModal className={this.props.className}
                        contentLabel={this.props.contentLabel || 'Modal'}
                        isOpen={this.props.show === true}
                        style={MODAL_STYLE_RESET}>
                {this.props.title != null ? (
                    <h2>{this.props.title}</h2>
                ) : null}
                {this.props.children}
            </ReactModal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js